import Vue from 'vue'
import Router from 'vue-router'
import RouterName from '@/constants/route'
import Detect from '@/util/detect'
import store from '@/store'

const isMobile = Detect(window.navigator.userAgent).mobile()

Vue.use(Router)

export const routes = [
  // can not use variable instead import path
  {
    path: '/login',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-login-mobile" */
            '@/views/login/mobile'
          )
        : import(
            /* webpackChunkName: "views-login-desktop" */
            '@/views/login/desktop'
          ),
    name: RouterName.login
  },
  {
    path: '/simpleLogin',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-simpleLogin-mobile" */
            '@/views/simpleLogin/mobile'
          )
        : import(
            /* webpackChunkName: "views-simpleLogin-desktop" */
            '@/views/simpleLogin/desktop'
          ),
    name: RouterName.simpleLogin
  },
  {
    path: '/alumniLogin',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-simpleLogin-mobile" */
            '@/views/simpleLogin/mobile'
          )
        : import(
            /* webpackChunkName: "views-simpleLogin-desktop" */
            '@/views/simpleLogin/desktop'
          ),
    name: 'AlumniLogin'
  },
  {
    path: '/reallyAlumniLogin',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-alumniLogin-mobile" */
            '@/views/alumniLogin/mobile'
          )
        : import(
            /* webpackChunkName: "views-alumniLogin-desktop" */
            '@/views/alumniLogin/desktop'
          ),
    name: 'ReallyAlumniLogin'
  },
  {
    path: '/preview',
    component: () =>
      import(
        /* webpackChunkName: "views-preview" */
        '@/views/preview'
      ),
    name: RouterName.preview
  },
  {
    path: '/selfinfo',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-selfinfo-mobile" */
            '@/views/selfinfo/mobile'
          )
        : import(
            /* webpackChunkName: "views-selfinfo-desktop" */
            '@/views/selfinfo/desktop'
          ),
    name: RouterName.selfInfo
  },
  {
    path: '/coupon',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-coupon-mobile" */
            '@/views/coupon/mobile'
          )
        : import(
            /* webpackChunkName: "views-coupon-desktop" */
            '@/views/coupon/desktop'
          ),
    name: RouterName.coupon
  },
  {
    path: '/update',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-update-mobile" */
            '@/views/update/mobile'
          )
        : import(
            /* webpackChunkName: "views-update-desktop" */
            '@/views/update/desktop'
          ),
    name: RouterName.update
  },
  {
    path: '/updateprofile',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-update-mobile" */
            '@/views/updateprofile/mobile'
          )
        : import(
            /* webpackChunkName: "views-update-desktop" */
            '@/views/updateprofile/desktop'
          ),
    name: RouterName.updateProfile
  },
  {
    path: '/coutryCodePane',
    component: () =>
      import(
        /* webpackChunkName: "views-country-mobile" */
        '@/views/country'
      ),
    name: RouterName.countryPane
  },
  {
    path: '/home',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-home-mobile" */
            '@/views/home/mobile'
          )
        : import(
            /* webpackChunkName: "views-home-desktop" */
            '@/views/home/desktop'
          ),
    name: RouterName.home
  },
  {
    path: '/registeredEvents',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-registered-mobile" */
            '@/views/registeredevent/mobile'
          )
        : import(
            /* webpackChunkName: "views-registered-desktop" */
            '@/views/registeredevent/desktop'
          ),
    name: RouterName.registeredEvents
  },
  {
    path: '/registerForm',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-registerform-mobile" */
            '@/views/registerform/mobile'
          )
        : import(
            /* webpackChunkName: "views-registerform-desktop" */
            '@/views/registerform/desktop'
          ),
    name: RouterName.registerForm
  },
  {
    path: '/approvedEvents',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-approve-mobile" */
            '@/views/approvedevent/mobile'
          )
        : import(
            /* webpackChunkName: "views-approve-desktop" */
            '@/views/approvedevent/desktop'
          ),
    name: RouterName.approvedEvents
  },
  {
    path: '/qrcode',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-qrcode-mobile" */
            '@/views/qrcode/mobile'
          )
        : import(
            /* webpackChunkName: "views-qrcode-desktop" */
            '@/views/qrcode/desktop'
          ),
    name: RouterName.qrcode
  },
  {
    path: '/eventDetail',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-event-mobile" */
            '@/views/event/mobile'
          )
        : import(
            /* webpackChunkName: "views-event-desktop" */
            '@/views/event/desktop'
          ),
    name: RouterName.eventDetail
  },
  {
    path: '/newEventDetail',
    component: () =>
      isMobile
        ? import('@/views/newEventDetail/mobile/index.vue')
        : import('@/views/newEventDetail/mobile/index.vue'),
    name: RouterName.newEventDetail
  },
  // default page
  {
    path: '/404',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-event-mobile" */
            '@/views/layout/mobile/404'
          )
        : import(
            /* webpackChunkName: "views-event-desktop" */
            '@/views/layout/desktop/404'
          ),
    name: RouterName.noFound
  },
  {
    path: '/publicEvent',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-event-mobile" */
            '@/views/event/mobile'
          )
        : import(
            /* webpackChunkName: "views-event-desktop" */
            '@/views/event/desktop'
          ),
    name: RouterName.publicEvent
  },
  {
    path: '/newEvent',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-event-mobile" */
            '@/views/newEvent/mobile'
          )
        : import(
            /* webpackChunkName: "views-event-desktop" */
            // '@/views/newEvent/desktop'
            '@/views/newEvent/mobile'
          ),
    name: RouterName.newEvent
  },
  {
    path: '/survey',
    component: () =>
      import(
        /* webpackChunkName: "views-question" */
        '@/views/question'
      ),
    name: RouterName.survey
  },
  {
    path: '/apply-welcome',
    component: () =>
      import(
        /* webpackChunkName: "views-apply-welcome" */
        '@/views/apply/welcome'
      ),
    name: 'ApplyWelcome'
  },
  {
    path: '/apply',
    component: () =>
      import(
        /* webpackChunkName: "views-apply" */
        '@/views/apply'
      ),
    name: RouterName.apply
  },
  {
    path: '/apply-thanks',
    component: () =>
      import(
        /* webpackChunkName: "views-thanks" */
        '@/views/apply/thanks'
      ),
    name: RouterName.applyThanks
  },
  {
    path: '/survey-new',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-survey-new-mobile" */
            '@/views/survey/mobile'
          )
        : import(
            /* webpackChunkName: "views-survey-new-desktop" */
            '@/views/survey/desktop'
          ),
    name: RouterName.surveyNew
  },
  {
    path: '/survey-thanks',
    component: () =>
      import(
        /* webpackChunkName: "views-survey-common-thanks" */
        '@/views/survey/common/thanks'
      ),
    name: RouterName.surveyThanks
  },
  {
    path: '/counselling',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-counselling-mobile" */
            '@/views/counselling/mobile'
          )
        : import(
            /* webpackChunkName: "views-counselling-desktop" */
            '@/views/counselling/desktop'
          ),
    name: RouterName.counselling
  },
  {
    path: '/course',
    component: () =>
      import(
        /* webpackChunkName: "views-course" */
        '@/views/video'
      ),
    name: RouterName.video
  },
  {
    path: '/course/detail',
    component: () =>
      import(
        /* webpackChunkName: "views-course-detail" */
        '@/views/video/detail'
      ),
    name: RouterName.videoDetail
  },
  {
    path: '/self-diagnosis',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-selfdiagnosis-mobile" */
            '@/views/selfdiagnosis/mobile'
          )
        : import(
            /* webpackChunkName: "views-selfdiagnosis-desktop" */
            '@/views/selfdiagnosis/desktop'
          ),
    name: RouterName.selfDiagnosis
  },
  {
    path: '/internshipChallenge',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-internshipchallenge-mobile" */
            '@/views/internshipchallenge/mobile'
          )
        : import(
            /* webpackChunkName: "views-internshipchallenge-desktop" */
            '@/views/internshipchallenge/desktop'
          ),
    name: RouterName.internshipChallenge
  },
  {
    path: '/icAssistant',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-icAssistant-mobile" */
            '@/views/icAssistant/mobile'
          )
        : import(
            /* webpackChunkName: "views-icAssistant-desktop" */
            '@/views/icAssistant/mobile'
          ),
    name: RouterName.icAssistant
  },
  {
    path: '/share',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-share-mobile" */
            '@/views/share/mobile'
          )
        : import(
            /* webpackChunkName: "views-share-desktop" */
            '@/views/share/desktop'
          ),
    name: RouterName.share
  },
  {
    path: '/ic-test',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-ic-test-mobile" */
            '@/views/icTest/mobile'
          )
        : import(
            /* webpackChunkName: "views-ic-test-desktop" */
            '@/views/icTest/mobile'
          ),
    name: RouterName.icTest
  },
  {
    path: '/pick-class',
    component: () =>
      isMobile
        ? import(
            /* webpackChunkName: "views-ic-test-mobile" */
            '@/views/pickClass/mobile'
          )
        : import(
            /* webpackChunkName: "views-ic-test-desktop" */
            '@/views/pickClass/desktop'
          ),
    name: RouterName.pickClass
  },
  {
    path: '/m/statement',
    component: () =>
      isMobile ? import('@/views/m/Statement') : import('@/views/m/Statement'),
    name: RouterName.statement
  },
  {
    path: '/m',
    component: () =>
      isMobile ? import('@/views/m/index') : import('@/views/m/index'),
    name: RouterName.mobile
  },
  {
    path: '/m/article/:cat',
    component: () =>
      isMobile
        ? import('@/views/m/Article.vue')
        : import('@/views/m/Article.vue'),
    name: RouterName.article
  },
  {
    path: '/m/menuList/:cat',
    component: () =>
      isMobile
        ? import('@/views/m/MenuList.vue')
        : import('@/views/m/MenuList.vue'),
    name: RouterName.menuList
  },
  {
    path: '/m/diagnosis',
    component: () =>
      isMobile
        ? import('@/views/m/Diagnosis.vue')
        : import('@/views/m/Diagnosis.vue'),
    name: RouterName.diagnosis
  },
  {
    path: '/m/careerProgrammes',
    component: () =>
      isMobile
        ? import('@/views/m/CareerProgrammes.vue')
        : import('@/views/m/CareerProgrammes.vue'),
    name: RouterName.careerProgrammes
  },
  {
    path: '/m/articleDetail',
    component: () =>
      isMobile
        ? import('@/views/m/ArticleDetail.vue')
        : import('@/views/m/ArticleDetail.vue'),
    name: RouterName.articleDetail
  },
  {
    path: '/m/youPlusProgramme',
    component: () =>
      isMobile
        ? import('@/views/m/YouPlusProgramme.vue')
        : import('@/views/m/YouPlusProgramme.vue'),
    name: RouterName.youPlusProgramme
  },
  {
    path: '/m/youPlusAnchorPro',
    component: () =>
      isMobile
        ? import('@/views/m/YouPlusAnchorPro.vue')
        : import('@/views/m/YouPlusAnchorPro.vue'),
    name: RouterName.youPlusAnchorPro
  },

  {
    path: '/m/anchorDiscovery',
    component: () =>
      isMobile
        ? import('@/views/m/AnchorDiscovery.vue')
        : import('@/views/m/AnchorDiscovery.vue'),
    name: RouterName.anchorDiscovery
  },
  {
    path: '/m/anchorExplorer',
    component: () =>
      isMobile
        ? import('@/views/m/AnchorExplorer.vue')
        : import('@/views/m/AnchorExplorer.vue'),
    name: RouterName.anchorExplorer
  },
  {
    path: '/m/anchorChallenger',
    component: () =>
      isMobile
        ? import('@/views/m/AnchorChallenger.vue')
        : import('@/views/m/AnchorChallenger.vue'),
    name: RouterName.anchorChallenger
  },
  {
    path: '/wechat',
    component: () =>
      import(
        /* webpackChunkName: "views-wechat" */
        '@/views/wechat'
      ),
    name: RouterName.wechat
  },
  {
    path: '/',
    redirect: { name: RouterName.home }
  },
  {
    path: '*',
    redirect: { name: RouterName.noFound }
  },
  // IC Event
  {
    path: '/drawlots',
    component: () =>
      import(
        /* webpackChunkName: "views-drawlots" */
        '@/views/drawlots'
      ),
    name: RouterName.drawlots
  }
]

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  // base: '/application/',
  routes: routes,
  mode: 'hash'
})
// 解决跳转promise 报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalReplace.call(this, location, onResolve, onReject) }
  return originalReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  /* must call `next` */
  if (
    to.query.param === undefined ||
    (!to.query.referId && from.query.referId)
  ) {
    let param = ''
    let referId = ''
    let query = {}
    if (!to.query.param && location.pathname.includes('/application/')) {
      param = from.query.code || from.query.param || 'E5842473F0953D22'
    }
    if (!to.query.referId && from.query.referId) {
      referId = from.query.referId
    }
    if (referId) {
      query = Object.assign({}, to.query, { referId })
    }
    if (param !== undefined) {
      query = Object.assign({}, to.query, { param })
    }
    console.log(query)
    next({
      path: to.path,
      query
    })
  } else {
    next()
  }
})

const replace = router.replace
router.replace = function() {
  const info = arguments[0]
  if (!info.query || !info.query.campaignCode) {
    arguments[0] = Object.assign({}, info, {
      query: Object.assign({}, info.query, {
        campaignCode: store.getters.campaignCode
      })
    })
  }
  return replace.apply(router, arguments)
}

export default router
